import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Drop2 = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M15.758 21.25c4.004 0 7.25-3.22 7.25-7.194 0-4.155-3.917-8.671-5.992-10.773-.703-.712-1.516-.783-2.516 0'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
        <path
          d='M7.742 3.282a1.75 1.75 0 0 1 2.516 0c1.038 1.051 2.536 2.706 3.774 4.617 1.239 1.912 2.218 4.08 2.218 6.157 0 3.973-3.246 7.194-7.25 7.194s-7.25-3.22-7.25-7.194c0-2.077.98-4.245 2.218-6.157 1.238-1.91 2.736-3.566 3.774-4.617'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M10.791 2.755a2.5 2.5 0 0 0-3.582 0c-1.057 1.07-2.594 2.766-3.87 4.737C2.071 9.446 1 11.762 1 14.056 1 18.449 4.587 22 9 22s8-3.551 8-7.944c0-2.294-1.072-4.61-2.338-6.564-1.277-1.971-2.814-3.667-3.87-4.737'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.853 3.472c-.181-.004-.47.072-.89.401l-.925-1.181c.579-.453 1.197-.733 1.848-.72.665.015 1.218.333 1.663.784 1.057 1.07 2.593 2.765 3.87 4.736 1.267 1.954 2.339 4.27 2.339 6.564 0 4.393-3.587 7.945-8 7.945v-1.5c3.595 0 6.5-2.891 6.5-6.445 0-1.861-.886-3.88-2.097-5.748-1.2-1.852-2.66-3.466-3.68-4.498-.257-.261-.46-.334-.628-.338'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
